import React, { useState, useEffect } from 'react';

import { get } from '../../core/client';
import Spinner from '../ui/spinner';

export const SendMailToProfile = (props: any) => {
    const [message, setMessage] = useState<string>('');
    const [userMessage, setUserMessage] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const code: string = props?.match?.params?.code;

    const getSendMailToProfile = async () => {
        const baseURL = `users/send-profile-fullness-ratio-mail?code=${code}`;
        await get<any>(baseURL)
            .then(res => {
                if (res.isSuccessful) {
                    setMessage(res?.result?.message);
                    setIsLoading(true);
                } else {
                    setMessage(res?.error?.message);
                }
            })
            .catch(e => {
                setMessage(e?.error?.message);
                setIsLoading(true);
            })
            .finally(() =>
                setTimeout(() => {
                    setIsLoading(false);
                }, 2000),
            );
    };

    const getSendMailToProfileByUser = async () => {
        const baseURL = `users/send-mail-to-profile-by-user?code=${code}`;
        await get<any>(baseURL)
            .then(res => {
                if (res.isSuccessful) {
                    setUserMessage(res?.result?.message);
                    setIsLoading(true);
                } else {
                    setUserMessage(res?.error?.message);
                }
            })
            .catch(e => {
                setUserMessage(e?.error?.message);
                setIsLoading(true);
            })
            .finally(() =>
                setTimeout(() => {
                    setIsLoading(false);
                }, 2000),
            );
    };
    useEffect(() => {
        if (code?.length > 0 && props?.match?.path === '/send-mail-to-profile/:code') {
            getSendMailToProfile();
        } else if (code?.length > 0 && props?.match?.path === '/send-mail-to-profile-by-user/:code') {
            getSendMailToProfileByUser();
        }
    }, [code]);

    return (
        <>
            {isLoading ? (
                <Spinner />
            ) : (
                <div className="not-support-page show">
                    <div className="not-support-content">{message ? message : userMessage}</div>
                </div>
            )}
        </>
    );
};

export default SendMailToProfile;
